import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ShareServiceImpl } from './services/impls/share-service';
import { ShareService } from './services/share-service';
import { ShareIdApi } from './apis/share-id-api';
import { ShareIdApiImpl } from './apis/impls/share-id-api';
import { EmailInviteApi } from './apis/email-invite-api';
import { EmailInviteApiImpl } from './apis/impls/email-invite-api';
import { ShareIdRepositoryImpl } from './repositories/impls/share-id-repository';
import { EmailInviteRepositoryImpl } from './repositories/impls/email-invite-repository';
import { ShareAccessCheckApi } from './apis/share-access-check-api';
import { ShareAccessCheckApiImpl } from './apis/impls/share-access-check-api';
import { ShareOwnerInfoApi } from './apis/share-owner-info-api';
import { ShareOwnerInfoApiImpl } from './apis/impls/share-owner-info-api';
import { DuplicateCreateApi } from './apis/duplicate-create-api';
import { DuplicateExecuteApi } from './apis/duplicate-execute-api';
import { DuplicateCreateApiImpl } from './apis/impls/duplicate-create-api';
import { DuplicateExecuteApiImpl } from './apis/impls/duplicate-execute-api';
import {
  DuplicateCreateRepository,
  DuplicateExecuteRepository,
  ShareIdRepository,
  EmailInviteRepository,
  ShareAccessCheckRepository,
  ShareOwnerInfoRepository,
} from './services/share-tools-repository';
import { DuplicateCreateRepositoryImpl } from './repositories/impls/duplicate-create-repository';
import { DuplicateExecuteRepositoryImpl } from './repositories/impls/duplicate-execute-repository';
import { DuplicateService } from './services/duplicate-service';
import { DuplicateServiceImpl } from './services/impls/duplicate-service';
import { ShareAccessCheckRepositoryImpl } from './repositories/impls/share-access-check-repository';
import { ShareOwnerInfoRepositoryImpl } from './repositories/impls/share-owner-info-repository';
import { AuthService } from './services/auth-service';
import { AuthServiceImpl } from './services/impls/auth-service';
import { AuthModel } from './models/auth.model';
import { AuthModelImpl } from './models/impls/auth.model';
import {
  ShareUnauthenticatedHandler,
  ShareUnauthenticatedHandlerImpl,
} from './services/share-unauthenticated-service';
import { ProjectShareApi } from './apis/project-share-api';
import { ProjectShareApiImpl } from './apis/impls/project-share-api';
import { ProjectShareService } from './services/project-share-service';
import { ProjectShareServiceImpl } from './services/impls/project-share-service';
import { ShareI18nService } from './services/share-i18n-service';
import { i18n } from '../i18n';

export const shareModule = new ContainerModule((bind) => {
  bind(ShareI18nService).toConstantValue({
    t: i18n.global.t.bind(i18n),
    locale: i18n.global.locale.value,
  });
  bind(ShareIdApi).to(ShareIdApiImpl);
  bind(EmailInviteApi).to(EmailInviteApiImpl);
  bind(ShareAccessCheckApi).to(ShareAccessCheckApiImpl);
  bind(ShareOwnerInfoApi).to(ShareOwnerInfoApiImpl);
  bind(ShareIdRepository).to(ShareIdRepositoryImpl);
  bind(EmailInviteRepository).to(EmailInviteRepositoryImpl);
  bind(ShareAccessCheckRepository).to(ShareAccessCheckRepositoryImpl);
  bind(ShareOwnerInfoRepository).to(ShareOwnerInfoRepositoryImpl);
  bind(DuplicateCreateApi).to(DuplicateCreateApiImpl);
  bind(DuplicateExecuteApi).to(DuplicateExecuteApiImpl);
  bind(DuplicateCreateRepository).to(DuplicateCreateRepositoryImpl);
  bind(DuplicateExecuteRepository).to(DuplicateExecuteRepositoryImpl);
  bind(ShareService).to(ShareServiceImpl);
  bind(DuplicateService).to(DuplicateServiceImpl);
  bind(AuthService).to(AuthServiceImpl);
  bind(AuthModel).to(AuthModelImpl);
  bind(ShareUnauthenticatedHandler).to(ShareUnauthenticatedHandlerImpl);
  bind(ProjectShareApi).to(ProjectShareApiImpl);
  bind(ProjectShareService).to(ProjectShareServiceImpl);
});
